import { Injectable } from '@angular/core';
import { HttpClient } from '../_services/global-http.service';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

import { UserAdminRow, AdminUserPaginationApi } from '../_models/user';
import { PaginationParams } from '../_models/generic';
import { Utilities } from '../_utilities/Utilities';
import { environment } from 'environments/environment';
import { AuthenticationService } from './authentication.service';

@Injectable()
export class UsersService {
  constructor(private http: HttpClient, private auth: AuthenticationService) { }

  data: any;

  findAdminVehicles(params: PaginationParams): Observable<AdminUserPaginationApi> {
    const _params = Utilities.convertPaginationParameters(params);
    return this.http.get<AdminUserPaginationApi>('/api/administration/users/', { params: _params });
  }

  async getNewUserInfo() {
    const headers = new Headers();
    headers.append('Authorization', `Bearer ${this.auth.getAuthCookie()}`);

    return (await fetch(`${environment.dataliveAuthHost}/userinfo`, { headers })).json();
  }

  getUsers() {
    this.data = this.http.get(`/api/users/`);
    return this.data;
  }

  getUsersAdmin(params: PaginationParams) {
    this.data = this.http.get(`/api/administration/users/`, { params: params });
    return this.data;
  }

  getUser(id: number) {
    const apiUpdateUser: string = '/api/user/' + id + '/';
    this.data = this.http.get(apiUpdateUser);
    return this.data;
  }

  getUserInfo() {
    this.data = this.http.get(`/api/user/get_current_user/`);
    return this.data;
  }

  getUsersForGroup() {
    this.data = this.http.get('/api/users_for_group/');
    return this.data;
  }
}



// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_services/users.service.ts